import React from 'react';
import AddOrEditProcess from './AddOrEditProcessComponent';
import AddOrEditProcessComponent from './AddOrEditProcessComponent';

export default (props) => {
    return <AddOrEditProcessComponent location={props.location} />;
}
